import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useConfirm } from "@hulahoop/ui";
import { useAuth } from "@/contexts/AuthContext";

export function useShellSignOut() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const { confirm, dialog } = useConfirm();
  const request = useCallback(
    () =>
      confirm({
        title: t("shell.sign_out_title"),
        description: t("shell.sign_out_description"),
        actionLabel: t("nav.logout"),
        run: async () => {
          await logout();
          return t("shell.sign_out_done");
        },
      }),
    [confirm, logout, t],
  );
  return { request, dialog };
}
